// api
import PresentationApi from '@/api/presentation'

const setPresentationAction = ({ commit }: any, presentation: object) => {
  commit('setPresentation', presentation)
}

const getPresentationAction = async ({ commit }: any, moderationCode: string) => {
  const presentation = await PresentationApi.getPresentation(moderationCode)
  commit('setPresentation', presentation)

  return presentation
}

export default {
  setPresentationAction,
  getPresentationAction,
}
